import { motion } from "framer-motion";
import styles from "../styles/index";
import { fadeIn, staggerContainer, zoomIn } from "../utils/motion";
import { useTranslation } from "react-i18next";
import persianGulfImg from "../public/persianGulfImg.png";
import { CiLocationOn } from "react-icons/ci";
import stamp from "../public/stamp.png";

const PersianGulfAbout = () => {
  const { t } = useTranslation();
  return (
    <section className={`${styles.paddings}`}>
      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.25 }}
        className={`flex lg:flex-row flex-col  ${styles.innerWidth}`}
      >
        <motion.div
          variants={fadeIn("right", "tween", 0.2, 1)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
          className="flex-[.5] lg:max-w-[370px] flex justify-end flex-col gradient-05 sm:p-8 p-4 rounded-[32px] border-[1px] border-[#6A6A6A] relative"
        >
          <div className="feedback-gradient" />

          <div>
            <h4 className="font-bold sm:text-[32px] text-[26px] sm:leading-[40.32px] leading-[36.32px] dark:text-white text-Darktext">
              {t("Bushehrseaport")}
            </h4>
            <div className="flex">
              <span>
                <CiLocationOn className="mt-[8px] font-normal sm:text-[18px] text-[12px] sm:leading-[22.68px] leading-[16.68px] dark:text-white text-Darktext" />
              </span>
              <p className="mt-[8px] font-normal sm:text-[18px] text-[12px] sm:leading-[22.68px] leading-[16.68px] dark:text-white text-Darktext">
                {t("PersianGulf")}
              </p>
            </div>
          </div>
          <div>
            <p className="mt-[24px] font-normal sm:text-[24px] text-[18px] sm:leading-[45.6px] leading-[39.6px] dark:text-white text-Darktext">
              {t("BushehrseaportAbaut")}
            </p>
          </div>
        </motion.div>
        <motion.div
          variants={fadeIn("left", "tween", 0.2, 1)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
          className="relative flex-1 flex justify-center items-center"
        >
          <img
            src={persianGulfImg}
            alt="persianGulfImg"
            className="w-full lg:h-[610px] h-auto min-h-[210px] object-cover rounded-[40px]"
          />
          <motion.div
            variants={zoomIn(0.4, 1)}
            className="lg:block hidden absolute -left-[9%] top-[3%]"
          >
            <img
              src={stamp}
              alt="stamp"
              className="w-[155px] h-[155px] object-contain"
            />
          </motion.div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default PersianGulfAbout;
